import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const KEY = "goldenelia_consent";

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(KEY);
    if (!saved) {
      // Show after a brief delay so it doesn't fight with the hero animation
      const t = setTimeout(() => setShow(true), 1400);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(
      KEY,
      JSON.stringify({ status: "accepted", ts: new Date().toISOString() })
    );
    setShow(false);
  };

  const reject = () => {
    localStorage.setItem(
      KEY,
      JSON.stringify({ status: "essential-only", ts: new Date().toISOString() })
    );
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 sm:px-6 sm:pb-6 pointer-events-none"
    >
      <div
        className="pointer-events-auto max-w-4xl mx-auto p-5 sm:p-7 border border-[color:var(--goldenelia-gold)]/35"
        style={{
          background: "rgba(8,8,8,0.94)",
          backdropFilter: "blur(18px) saturate(140%)",
          WebkitBackdropFilter: "blur(18px) saturate(140%)",
          boxShadow: "0 24px 60px -16px rgba(0,0,0,0.8)",
        }}
      >
        <div className="flex flex-col md:flex-row md:items-center gap-5 md:gap-8">
          <div className="flex-1">
            <p className="font-display text-[9px] sm:text-[10px] tracking-[0.45em] uppercase text-[color:var(--goldenelia-gold)] mb-2">
              Cookies & Απόρρητο
            </p>
            <p className="font-body text-[13px] sm:text-sm text-[color:var(--goldenelia-cream)]/85 leading-relaxed">
              Χρησιμοποιούμε μόνο τα απαραίτητα cookies για το καλάθι, τη γλώσσα και την
              ασφάλεια. Διαβάστε την{" "}
              <Link
                to="/cookies"
                data-testid="cookie-link-policy"
                className="text-[color:var(--goldenelia-gold)] underline underline-offset-2 hover:text-[color:var(--goldenelia-gold-bright)]"
              >
                Πολιτική Cookies
              </Link>{" "}
              μας.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <button
              data-testid="cookie-reject-btn"
              onClick={reject}
              className="btn-ghost-gold !px-6 !py-3 text-[10px] whitespace-nowrap"
            >
              Μόνο απαραίτητα
            </button>
            <button
              data-testid="cookie-accept-btn"
              onClick={accept}
              className="btn-solid-gold !px-6 !py-3 text-[10px] whitespace-nowrap"
            >
              Αποδοχή όλων
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
